import { render, staticRenderFns } from "./CommentField.vue?vue&type=template&id=3a5d58b4&"
import script from "./CommentField.vue?vue&type=script&lang=js&"
export * from "./CommentField.vue?vue&type=script&lang=js&"
import style0 from "./CommentField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports